"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var d3_1 = require("d3");
var data_model_1 = require("../data-model");
var dictionaryMap_1 = require("../../i18n/constants/dictionaryMap");
var Map = /** @class */ (function () {
    function Map(ctx, helpers) {
        /**
         * 地图类型
         */
        this.mapType = "china";
        /**
         * geo数据链接
         */
        this.geoJsonUrl = "";
        /**
         * 语言类型，目前仅中英文
         */
        this.mapLanguage = "zh";
        /**
         * 图形设置
         */
        this.options = {
            dataLabels: {
                enable: false,
            },
        };
        /**
         * 当前geo数据类型
         */
        this.geoJsonType = "";
        var cls = ctx.classPrefix + "-chart-series-group";
        this.ctx = ctx;
        this.helpers = helpers;
        this.model = new data_model_1.DataModel();
        this.gradientDefs = this.ctx.root.append("defs");
        this.gradientRect = this.ctx.root.append("g");
        // 如果图形绘制区默认先使用已存在的绘制区，如果没有则创建一个
        this.seriesGroup = this.ctx.root.select("." + cls);
        if (!this.seriesGroup.node()) {
            this.seriesGroup = this.ctx.root
                .append("g")
                .attr("class", cls)
                .attr("data-z-index", "3");
        }
    }
    /**
     * @implements Shape
     * @param pos 数据映射关系
     * @since 2.0
     */
    Map.prototype.position = function (pos) {
        var _a;
        var _this = this;
        var language = this.mapLanguage;
        var dataSource = this.ctx.dataSource.map(function (item) {
            var type = item.type;
            if (_this.mapType === "world") {
                type =
                    dictionaryMap_1.countryCode[language] && dictionaryMap_1.countryCode[language][type]
                        ? dictionaryMap_1.countryCode[language][type]
                        : type;
            }
            if (_this.mapType === "china") {
                type =
                    dictionaryMap_1.provinceCode[language] && dictionaryMap_1.provinceCode[language][type]
                        ? dictionaryMap_1.provinceCode[language][type]
                        : type;
            }
            item.type = type;
            return item;
        });
        this.model.source(dataSource);
        if (typeof pos === "string") {
            _a = tslib_1.__read(pos.split("*"), 2), this.categoryKey = _a[0], this.valueKey = _a[1];
        }
        return this;
    };
    Map.prototype.color = function (color) {
        if (Array.isArray(color)) {
            this.ctx.theme.color = color;
        }
        else if (typeof color === "object" && color !== null) {
            var formatter = color.formatter, colors = color.colors;
            if (colors) {
                this.ctx.theme.color = colors;
            }
            else {
                this.ctx.theme.color = null;
            }
            if (formatter) {
                this.colorAttrCallback = formatter;
            }
        }
        return this;
    };
    Map.prototype.registerMap = function (geoJSON) {
        this.geoJSON = geoJSON;
        return this;
    };
    Map.prototype.updateModel = function () {
        this.model.define(this.categoryKey, this.valueKey, "default", "default");
    };
    /**
     * 更新颜色比例尺
     * @since 2.3
     */
    Map.prototype.updateColorScale = function () {
        var domain = this.ctx.getOption("scale." + this.valueKey, {
            domain: null,
        }).domain;
        var autofit = domain === "autofit";
        var valueDomain = Array.isArray(domain)
            ? domain
            : this.model.getExtent(autofit);
        var _a = tslib_1.__read(valueDomain, 2), min = _a[0], max = _a[1];
        var _b = this.ctx.theme, color = _b.color, defaultColor = _b.defaultColor;
        var colorRange = [];
        if (Array.isArray(color)) {
            colorRange = color;
        }
        else {
            colorRange = defaultColor;
        }
        this.colorScale = d3_1.scaleLinear()
            .domain([min, max])
            .range(colorRange);
    };
    Map.prototype.draw = function () {
        var _this = this;
        this.updateModel();
        this.updateColorScale();
        this.downLoadGeoJSON(this.geoJsonUrl).then(function () {
            _this.drawMap();
            _this.drawGradientRect();
        });
        return this;
    };
    Map.prototype.downLoadGeoJSON = function (geoJsonUrl) {
        if (geoJsonUrl === void 0) { geoJsonUrl = ""; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, dictionary_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.geoJSON || this.geoJsonType !== this.mapType)) return [3 /*break*/, 2];
                        this.geoJsonType = this.mapType;
                        _a = this;
                        return [4 /*yield*/, fetchGeoJSON(this.mapType, geoJsonUrl)];
                    case 1:
                        _a.geoJSON = _b.sent();
                        dictionary_1 = dictionaryMap_1.dictionaryMap[this.mapLanguage];
                        this.geoJSON.features.map(function (item) {
                            var name = item.properties.name;
                            name = dictionary_1[name] ? dictionary_1[name] : name;
                            item.properties.name = name;
                            return item;
                        });
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Map.prototype.drawMap = function () {
        var _this = this;
        var classPrefix = this.ctx.classPrefix;
        var cls = classPrefix + "-chart-map";
        var height = this.ctx.getBackgroundHeight();
        var width = this.ctx.getBackgroundWidth();
        var projection = d3_1.geoMercator().fitSize([width, height], this.geoJSON);
        var path = d3_1.geoPath().projection(projection);
        this.seriesGroup.selectAll("path." + cls).remove();
        var that = this;
        var tooltipTimer;
        var tooltipActived = false;
        if (this.geoJSON && this.geoJSON.features) {
            this.mapPathGroup = this.seriesGroup
                .selectAll("path." + cls)
                .data(this.geoJSON.features)
                .enter()
                .append("path")
                .classed(cls, true)
                .attr("stroke", function (d) {
                var name = d.properties.name;
                if (["", "海南省", "台湾省"].includes(name))
                    return "#b2b2b2";
                return "#FFFFFF";
            })
                .attr("data-name", function (d) { return d.properties.name; })
                .attr("d", path)
                .style("cursor", "pointer")
                .attr("fill", function (d) {
                var name = d.properties.name;
                var alias = _this.ctx.getOption("scale." + _this.valueKey + ".alias");
                var values = _this.model.getDataFromCategoryName(name, false, false);
                var _a = values[0] || {}, serieName = _a.serieName, _b = _a.value, value = _b === void 0 ? null : _b, origin = _a.origin;
                var metaData = {
                    title: name,
                    label: alias || _this.valueKey,
                    serieName: serieName,
                    valueText: typeof value === "number" ? d3_1.format(",")(value) : "-",
                    color: _this.colorScale(value),
                    value: value,
                    row: origin,
                };
                d.meta = metaData;
                return metaData.color;
            })
                .on("mouseenter", function enter() {
                var ele = d3_1.select(this);
                ele.style("fill", "#FFF2CF");
            })
                .on("mouseleave", function leave(d) {
                var ele = d3_1.select(this);
                var color = d.meta.color;
                ele.style("fill", color);
                clearTimeout(tooltipTimer);
                tooltipActived = false;
                tooltipTimer = setTimeout(function () {
                    if (tooltipActived === false) {
                        that.helpers.tooltip.hide();
                    }
                }, 300);
            })
                .on("mousemove", function move(d) {
                var tooltipEnable = that.ctx.getOption("tooltip.enable");
                var meta = d.meta;
                if (tooltipEnable === false)
                    return;
                var data = {
                    x: d3_1.event && d3_1.event.offsetX,
                    y: d3_1.event && d3_1.event.offsetY,
                    category: meta.title,
                    metaData: [meta],
                    index: 0,
                };
                that.helpers.tooltip.show(data, that.model.getAllData());
                tooltipActived = true;
            })
                .on("click", function (d) {
                var selectEnable = _this.ctx.getOption("interaction.element-select");
                if (selectEnable) {
                    that.ctx.emit("interaction.selected", d.meta);
                }
            });
        }
    };
    Map.prototype.shape = function (cfg) {
        this.options = cfg;
        return this;
    };
    Map.prototype.setMapType = function (mapType) {
        if (mapType) {
            this.mapType = mapType;
        }
        return this;
    };
    Map.prototype.setGeoJsonUrl = function (geoJsonUrl) {
        if (geoJsonUrl) {
            this.geoJsonUrl = geoJsonUrl;
        }
        return this;
    };
    Map.prototype.language = function (language) {
        if (language) {
            this.mapLanguage = language;
        }
        return this;
    };
    Map.prototype.drawGradientRect = function () {
        var domain = this.ctx.getOption("scale." + this.valueKey, {
            domain: null,
        }).domain;
        var autofit = domain === "autofit";
        var valueDomain = Array.isArray(domain)
            ? domain
            : this.model.getExtent(autofit);
        var _a = tslib_1.__read(valueDomain, 2), min = _a[0], max = _a[1];
        var _b = this.ctx.theme, padding = _b.padding, xAxis = _b.xAxis;
        var height = this.ctx.getBackgroundHeight();
        this.gradientDefs.select("linearGradient").remove();
        this.gradientRect.select("rect").remove();
        this.gradientRect.selectAll("text").remove();
        var x = padding.left;
        if (this.seriesGroup.node()) {
            var _c = this.seriesGroup.node().getBoundingClientRect(), groupX = _c.x, width = _c.width;
            if (groupX) {
                x = groupX - width + 100;
            }
        }
        var linearGradient = this.gradientDefs
            .append("linearGradient")
            .attr("id", "linearColor")
            .attr("x1", "0%")
            .attr("y1", "100%")
            .attr("x2", "0%")
            .attr("y2", "0%");
        // 设置矩形条开始颜色
        linearGradient
            .append("stop")
            .attr("offset", "0%")
            .attr("stop-color", this.colorScale(min));
        // 设置结束颜色
        linearGradient
            .append("stop")
            .attr("offset", "100%")
            .attr("stop-color", this.colorScale(max));
        this.gradientRect
            .append("rect")
            .attr("x", x)
            .attr("y", height - 83 - padding.bottom)
            .attr("width", 16)
            .attr("height", 83)
            .style("fill", "url(#" + linearGradient.attr("id") + ")");
        this.gradientRect
            .append("text")
            .attr("x", x + 20)
            .attr("y", height - padding.bottom)
            .text(String(min))
            .attr("fill", xAxis.labelColor)
            .classed("linear-text", true);
        this.gradientRect
            .append("text")
            .attr("x", x + 20)
            .attr("y", height - 83 - padding.bottom + 8)
            .text(String(max))
            .attr("fill", xAxis.labelColor)
            .classed("linear-text", true);
    };
    return Map;
}());
exports.Map = Map;
/**
 * 按地图类型获取GeoJson数据
 *
 * @param type 地图类型
 */
function fetchGeoJSON(type, geoUrl) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var geoJsonUrl;
        return tslib_1.__generator(this, function (_a) {
            geoJsonUrl = geoUrl;
            if (geoJsonUrl) {
                return [2 /*return*/, d3_1.json(geoJsonUrl)];
            }
            /**
             * 开发环境可用(china)： "http://127.0.0.1:4314/static/china_map_geojson.202007211628.json";
             * 开发环境可用(world)： "http://127.0.0.1:4314/static/world_map_geojson.202012091746.json";
             */
            switch (type) {
                case "china":
                    geoJsonUrl =
                        "//cloudcache.tencent-cloud.com/qcloud/tea-chart/geojson/china_map_geojson.202007211628.json";
                    break;
                case "world":
                    geoJsonUrl =
                        "//cloudcache.tencent-cloud.com/qcloud/tea-chart/geojson/world_map_geojson.202012091746.json";
                    break;
                default:
                    geoJsonUrl =
                        "//cloudcache.tencent-cloud.com/qcloud/tea-chart/geojson/china_map_geojson.202007211628.json";
            }
            return [2 /*return*/, d3_1.json(geoJsonUrl)];
        });
    });
}
//# sourceMappingURL=map.js.map